import $ from 'jquery';
import d3 from 'd3';
import archiveViewTMPL from './archiveView.tmpl';

import facetViewTMPL from './facets/facetView.tmpl';
import StackFacetView from './facets/StackFacetView';
import PeriodicFacetView from './facets/PeriodicFacetView';
import HistogramFacetView from './facets/HistogramFacetView';
import TextFacetView from './facets/TextFacetView';
import TagFacetView from './facets/TagFacetView';
import { Signal } from 'signals';

import chartsCSS from './charts.styl';

export default class ArchiveView {

  constructor(archive, archiveConfig) {
    this.WIDGET_FACTORY_MAP = {
      StackWidget: this._createStackWidget,
      PeriodicWidget: this._createPeriodicWidget,
      TagsWidget: this._createTagWidget,
      TextWidget: this._createTextWidget,
      HistogramWidget: this._createHistogramWidget,
    };
    this._widgets = [];

    this._archive = archive;
    this._archiveConfig = archiveConfig;
    this._archive.dataChanged.add(data => this._onArchiveDataChanged(data));
    this._visibilityClicked = new Signal();
  }

  get DOM() {
    const $el = $(archiveViewTMPL(this._archiveConfig));

    this._$filteredNumDiv = $el.find('.selected B');
    this._$totalNumDiv = $el.find('.total B');
    const $fields = $el.find('.fields');
    for (const facetConfig of this._archiveConfig.facets) {
      const WidgetClass = this.WIDGET_FACTORY_MAP[facetConfig.widget];
      if (!WidgetClass) continue;

      const $facet = $(facetViewTMPL(facetConfig)).appendTo($fields);
      const $fieldDOM = $facet.find('.chart');
      let $title = $facet.find('.title');
      $title.on('click', () => this.toggleWidget($facet));
      let $search = null;
      let $clearSearch = null;
      const facet = this._archive.getFacet(facetConfig.id);
      const widget = WidgetClass(facetConfig, $fieldDOM, facet);
      if (facetConfig.searchable) {
        $search = $facet.find('.tagSearch');
        $clearSearch = $facet.find('.clearTagSearch');
        $search.on('keyup', () => {
          widget.search($search.val());
          $search.toggleClass("active", !!$search.val());
          $clearSearch.toggleClass("active", !!$search.val());
        });
        $clearSearch.on('click', () => {
          $search.val('');
          widget.search('');
          $search.removeClass("active");
          $clearSearch.removeClass("active");
        } );
      }
      $facet.find('.reset').on('click', e => {
        facet.clear(e);
        if ($search) {
          $search.val('');
          widget.search('');
          $search.removeClass("active");
          $clearSearch.removeClass("active");
        }
      });
      this._widgets.push(widget);
    }

    $el.find('.filters').on('click', () => $el.toggleClass('expanded'));
    return $el;
  }

  toggleWidget($facet) {
    $facet.find('.chart').slideToggle();
    $facet.find('.tagSearch').fadeToggle();
    $facet.find('.clearTagSearch').fadeToggle();
    $facet.find('.reset').fadeToggle();
  }

  layout() {
    this._widgets.forEach(w => w.redraw());
  }

  _createStackWidget(facetConfig, $fieldDOM, facet) {
    const facetView = new StackFacetView(facetConfig, $fieldDOM, ArchiveView.DEFAULT_MARGINS);
    facetView.title(facetConfig.id)
      // .colors(lightColors)
      .facet(facet)
      .yFormat(d3.format('.2%'))
      .xValue(d => d[facet.idKey])
      .yValue(d => d[facet.valueKey])
      .xLabel(d => d[facet.labelKey]);
    return facetView;
  }

  _createPeriodicWidget(facetConfig, $fieldDOM, facet) {
    const facetView = new PeriodicFacetView(facetConfig, $fieldDOM, ArchiveView.DEFAULT_MARGINS);
    facetView.title(facetConfig.id)
      // .colors(lightColors)
      .facet(facet)
      .innerRadius(30)
      .outerRadius(60)
      .spacing(0.05)
      .spacingBg(0.04)
      .labelPadding(25)
      .xValue(d => d[facet.idKey])
      .yValue(d => d[facet.valueKey])
      .xLabel(d => d[facet.labelKey]);

    return facetView;
  }

  _createTagWidget(facetConfig, $fieldDOM, facet) {
    const facetView = new TagFacetView(facetConfig, $fieldDOM, ArchiveView.DEFAULT_MARGINS);
    facetView.title(facetConfig.id)
      // .colors(lightColors)
      .facet(facet)
      .limit(10)
      .yScaleFunction(d3.scale.ordinal())
      .xValue(d => d[facet.valueKey])
      .xFormat(d => d.toLocaleString())
      .yValue(d => d[facet.idKey])
      .yLabel(d => d[facet.labelKey]);
    return facetView;
  }

  _createTextWidget(facetConfig, $fieldDOM, facet) {
    const facetView = new TextFacetView(facetConfig, $fieldDOM, ArchiveView.DEFAULT_MARGINS);
    facetView.facet(facet);
    return facetView;
  }

  _createHistogramWidget(facetConfig, $fieldDOM, facet) {
    const facetView = new HistogramFacetView(facetConfig, $fieldDOM, ArchiveView.DEFAULT_MARGINS);
    facetView.title(facetConfig.id)
      // .colors(lightColors)
      .facet(facet)
      .limit(10)
      .xScaleFunction(d3.scale.ordinal())
      .yValue(d => d[facet.valueKey])
      .xValue(d => d[facet.idKey])
      .xLabel(d => d[facet.labelKey]);
    return facetView;
  }

  _onArchiveDataChanged() {
    this._widgets.forEach(widget => widget.update());
    this._$totalNumDiv.text(this._archive.total.toLocaleString());
    this._$filteredNumDiv.text(this._archive.selected.toLocaleString());
  }

}

ArchiveView.DEFAULT_MARGINS = { top: 10, right: 0, bottom: 20, left: 0 };



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/sidebar/archive/ArchiveView.es6
 **/